import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import useDropdownItems from "../../hooks/useDropdownItems";
import "./DropdownOptionsEvent.scss";

export type DropdownOptionsEventProps = {
  itemId: number;
  onDelete: (id: number) => void;
  onModify: (id: number) => void;
  goToDetails: (id: number) => void;
};

const DropdownOptionsEvent = (props: DropdownOptionsEventProps) => {
  const items = useDropdownItems(props);

  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <Button
        type="link"
        icon={<MoreOutlined className="icon-more" />}
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  );
};

export default DropdownOptionsEvent;
